import { commandTypes, actionTypes } from '@/types';

export default {
	init(store) {
		this.swipeTargets = {
			leftArticleProperties: null,
			rightArticleProperties: null,
		};

		[...this.$el.querySelectorAll('[href]')].forEach($post => {
			const link = $post.getAttribute('href').trim();
			$post.removeAttribute('href'); // empty links to prefent ugly url dragging
			$post.dataset.url = link;
			if (!link) return;

			// get article swipe targets
			if (/setExhibition.*gesture=swipe-/.test(link)) {
				store.dispatch(actionTypes.parseCommands, {
					rawString: link,
					callback: (command, params) => {
						if (command !== commandTypes.setExhibition) return;

						const ArticleProperties = {
							exhibitionID: params.id,
							articleID: params.articleid,
						};

						if (params.gesture === 'swipe-left') {
							this.swipeTargets.leftArticleProperties = ArticleProperties;
						} else if (params.gesture === 'swipe-right') {
							this.swipeTargets.rightArticleProperties = ArticleProperties;
						}
					},
				});
			}
		});
	},
	destroy() {},
};
